import { withStyles, Button } from "@material-ui/core";

const styles = theme => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    textTransform: "none",
    fontSize: 20,
    padding: "10px 25px",
    lineHeight: 1.5,
    color: "#ffd",
    backgroundColor: "rgb(50,69,92)",
    borderRadius: 12,
    "&:hover": {
      backgroundColor: "rgba(38,38,38, 0.3)",
    },
    "&:active": {
      boxShadow: "0px 0px 30px #283B52, 0px 0px  30px rgb(50,69,92)",
    },
  },
  disabled: {
    opacity: '.6'
  }
});

export default withStyles(styles)(Button);